const DownloadButtonConstEN = {
  downloadFile: 'Download',
};

export default DownloadButtonConstEN;
